import _ from 'lodash';

import * as Dashboard from 'types';
import AppConstants from 'constants/AppConstants';

interface State {
  visibility: Dashboard.SectionVisibility;
  unassignedVisiblity: boolean;
}

export const initialState: State = {
  visibility: {},
  unassignedVisiblity: true,
};

function convertToObject(
  labels: string[],
  updater: (label: string) => boolean
): Dashboard.SectionVisibility {
  const result: Dashboard.SectionVisibility = {};
  _.forEach(labels, (label) => {
    result[label] = updater(label);
  });
  return result;
}

export default function reducer(state: State = initialState, action: BaseTockAction): State {
  const { type, payload } = action;
  switch (type) {
    case AppConstants.FLEX_CALENDAR_SECTIONS_OPEN_SECTION: {
      return {
        ...state,
        visibility: {
          ...state.visibility,
          ...convertToObject(payload, () => true),
        },
      };
    }
    case AppConstants.FLEX_CALENDAR_SECTIONS_CLOSE_SECTION: {
      return {
        ...state,
        visibility: {
          ...state.visibility,
          ...convertToObject(payload, () => false),
        },
      };
    }
    case AppConstants.FLEX_CALENDAR_SECTIONS_TOGGLE_SECTION: {
      return {
        ...state,
        visibility: {
          ...state.visibility,
          ...convertToObject(payload, (label) => !state.visibility[payload]),
        },
      };
    }
    case AppConstants.FLEX_CALENDAR_UNASSIGNED_SECTION_CLOSE_SECTION: {
      return {
        ...state,
        unassignedVisiblity: false,
      };
    }
    case AppConstants.FLEX_CALENDAR_UNASSIGNED_SECTION_OPEN_SECTION: {
      return {
        ...state,
        unassignedVisiblity: true,
      };
    }
    case AppConstants.FLEX_CALENDAR_UNASSIGNED_SECTION_TOGGLE_SECTION: {
      return {
        ...state,
        unassignedVisiblity: !state.unassignedVisiblity,
      };
    }
    default:
      return state;
  }
}
